import { Types } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { TopStores } from '../../types'
import { WFHStoresTopPayload } from './types'

/**
 * WFH Top Stores reducer
 */
const wfhStoresTop = buildAsyncStatReducer({
    key: Metrics.WFH_STORES_TOP,
    types: {
        request: Types.DASHBOARD_WFH_STORES_TOP.request,
        success: Types.DASHBOARD_WFH_STORES_TOP.success,
        failure: Types.DASHBOARD_WFH_STORES_TOP.failure,
    },
    transform: (state, { payload }): TopStores => {
        return payload.map(({ store_code: storeCode, count }: WFHStoresTopPayload) => ({
            storeCode,
            count,
        }))
    },
})

export default wfhStoresTop
